import { withLDConsumer } from 'launchdarkly-react-client-sdk';

const Button = ({ flags }) => {
    return flags.showTheButton ? <div><p>Button displayed</p></div> : <div><p>Button off</p></div>;
};

export default withLDConsumer()(Button);